// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"49e6290c","845":"c6c7233c"}[chunkId] + ".chunk.js";
};